module.exports = __webpack_public_path__ + "static/img/9.1c554b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/9.png
// module id = KEgh
// module chunks = 0